import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const unableToVerifyAddressMutation = gql`
  mutation unableToVerifyAddress(
    $customerId: String!
    $subjectId: String!
    $userId: String!
  ) {
    unableToVerifyAddress(customerId: $customerId, subjectId: $subjectId, userId: $userId)
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
}

export type UnableToVerifyData = {
  unableToVerify: string | unknown
}

export const useUnableToVerifyAddressMutation: WrappedMutation<
  UnableToVerifyData,
  MutationVars
> = () =>
  useMutation<UnableToVerifyData, MutationVars>(unableToVerifyAddressMutation, {
    client: agentClient,
  })
